import { Box, Theme, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18n";
import { useGetTransparentProcessStagesQuery } from "../../../../store/api/sellWithUsApiSlice";
import { TransparentProcessMobileTimeLine } from "./TransparentProcessMobileTimeLine";
import { TransparentProcessDesktopTimeLine } from "./TransparentProcessDesktopTimeLine";
import { IStage } from "../../interfaces";

export default function TransparentProcess() {
  const { t } = useTranslation(["sellWithUs"]);
  const isRTL = i18n.dir() === "rtl";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const [selectedStage, setSelectedStage] = useState(0);
  const { data: fetchedStages } = useGetTransparentProcessStagesQuery(
    i18n.language
  );
  const [stages, setStages] = useState<IStage[]>([]);

  useEffect(() => {
    if (fetchedStages) {
      const sortedStages = [...fetchedStages.data].sort(
        (a, b) => a.displayOrder - b.displayOrder
      );
      setStages(sortedStages);
    }
  }, [fetchedStages]);

  return (
    <Box
      sx={{
        p: isMobile ? 0 : 0,
        pb: 0,
        direction: isRTL ? "rtl" : "ltr",
        maxWidth: "100%",
        overflowX: "hidden",
        mx: isMobile ? "20px" : "20px",
        marginTop: isMobile ? "50px" : "150px",
      }}
    >
      {/* Title */}
      <Box
        sx={{
          display: "flex",
          fontFamily: isRTL ? "Noto Sans Hebrew" : "Frank Ruhl Libre",
          fontWeight: 600,
          fontSize: isMobile ? "24px" : "36px",
          justifyContent: "flex-start",
          height: { xs: "36px", md: "46px" },
          mb: downMd ? "30px" : "24px",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            textTransform: "uppercase",
            [isRTL ? "ml" : "mr"]: 1,
            px: 1,
            bgcolor: "#E8EFF2A1",
          }}
        >
          {t("transparent")}
        </Typography>
        <Typography variant="h2" sx={{ textTransform: "uppercase", mb: 4 }}>
          {t("process")}
        </Typography>
      </Box>

      {/* Timeline */}
      {downMd ? (
        <TransparentProcessMobileTimeLine
          selectedStage={selectedStage}
          setSelectedStage={setSelectedStage}
          stages={stages}
        />
      ) : (
        <TransparentProcessDesktopTimeLine
          selectedStage={selectedStage}
          setSelectedStage={setSelectedStage}
          stages={stages}
        />
      )}
    </Box>
  );
}
